module.exports = __webpack_public_path__ + "img/sq4m_feature_02.34a3a747.jpg";